module.exports = __webpack_public_path__ + "media/svg-new/won 3-57c38624.svg";